<button
  mat-raised-button
  [disabled]="disabled"
  [matMenuTriggerFor]="dropdownMenu"
  [ngStyle]="buttonStyles"
  [ngClass]="buttonClasses"
  [style.--cdw-dropdown-icon-color]="iconColor"
  [matTooltip]="disabled && disabledTooltip ? disabledTooltip : ''"
  [matTooltipDisabled]="!disabled || !disabledTooltip"
  class="cdw-dropdown-button"
  (click)="$event.stopPropagation()">
  <ng-container *ngIf="mode === 'wide'; else normalMode">
    <lib-cdw-icon
      *ngIf="customIcon && customIconPosition === 'left'"
      [icon]="customIcon"
      [useMatIcon]="useMatIcon"
      [size]="customIconSize || '30px'">
    </lib-cdw-icon>
    <span class="button-label-wide">{{ buttonLabel }}</span>
    <lib-cdw-icon
      [icon]="dropdownArrowIcon"
      [useMatIcon]="true"
      [size]="dropdownArrowIconSize || '30px'">
    </lib-cdw-icon>
  </ng-container>
  <ng-template #normalMode>
    <lib-cdw-icon
      *ngIf="dropdownArrowPosition === 'left'"
      [icon]="dropdownArrowIcon"
      [useMatIcon]="true"
      [size]="dropdownArrowIconSize || '30px'">
    </lib-cdw-icon>
    <lib-cdw-icon
      *ngIf="customIcon && customIconPosition === 'left'"
      [icon]="customIcon"
      [useMatIcon]="useMatIcon"
      [size]="customIconSize || '30px'">
    </lib-cdw-icon>
    {{ buttonLabel }}
    <lib-cdw-icon
      *ngIf="customIcon && customIconPosition === 'right'"
      [icon]="customIcon"
      [useMatIcon]="useMatIcon"
      [size]="customIconSize || '30px'">
    </lib-cdw-icon>
    <lib-cdw-icon
      *ngIf="dropdownArrowPosition === 'right'"
      [icon]="dropdownArrowIcon"
      [useMatIcon]="true"
      [size]="dropdownArrowIconSize || '30px'">
    </lib-cdw-icon>
  </ng-template>
</button>

<mat-menu #dropdownMenu="matMenu" [xPosition]="panelPosition" [class]="panelClass">
  <div
    *ngIf="infoText"
    class="cdw-dropdown-info-text"
    [style.background-color]="infoBackgroundColor"
    [style.font-family]="infoFontFamily"
    [style.font-size]="infoFontSize"
    [style.font-weight]="infoFontWeight"
    [style.color]="infoFontColor"
    (click)="$event.stopPropagation()">
    {{ infoText }}
  </div>
  <ng-container *ngFor="let option of options">
    <mat-divider *ngIf="option.separator"></mat-divider>
    <button
      *ngIf="!option.separator"
      mat-menu-item
      [disabled]="option.disabled"
      [matTooltip]="option.disabled && option.tooltip ? option.tooltip : ''"
      [matTooltipDisabled]="!option.disabled || !option.tooltip"
      matTooltipPosition="left"
      (click)="onOptionClick(option)"
      class="cdw-dropdown-menu-item">
      <lib-cdw-icon
        *ngIf="option.icon"
        [icon]="option.icon"
        [useMatIcon]="option.useMatIcon !== undefined ? option.useMatIcon : true"
        [outlined]="option.outlined !== undefined ? option.outlined : false"
        [fill]="option.fill !== undefined ? option.fill : false"
        [customColor]="option.iconColor"
        [size]="option.iconSize || '24px'">
      </lib-cdw-icon>
      <span>{{ option.label }}</span>
    </button>
  </ng-container>
</mat-menu>
